module.exports = __webpack_public_path__ + "assets/img/trust_2.be43f0fe.png";